// Copyright (c) 2017 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import moment from 'moment';
import t from 'tcomb';

const AllClaimsFacets = t.struct({
    claimDateRangeFacet: t.struct({
        dateRange: DateRange,
        maxDate: t.maybe(t.Number),
        minDate: t.maybe(t.Number)
    }),
    claimStatusFacet: t.struct({
        allowedStatus: t.list(KeyValuePair),
        isInitialLoad: t.Boolean,
        selectedClaimStatus: t.list(KeyValuePair)
    }),
    dateTypeFacet: KeyValuePair,
    dealerAccountsFacet: DealerAccountsFacet

}, 'AllClaimsFacets');

export const getDefaultState = () =>
    new AllClaimsFacets({
        claimDateRangeFacet: {
            dateRange: new DateRange({
                from: moment.utc().startOf('day').valueOf(),
                to: moment.utc().endOf('day').valueOf()
            }),
            maxDate: null,
            minDate: null
        },
        claimStatusFacet: {
            allowedStatus: [],
            isInitialLoad: true,
            selectedClaimStatus: []
        },
        claimTypesFacet: {
            allowedTypes: [],
            isInitialLoad: true,
            selectedClaimTypes: []
        },
        dateTypeFacet: new KeyValuePair({
            key: 'CREATED',
            value: 'CREATED'
        }),
        dealerAccountsFacet: getDealerAccountsFacetDefaultState()
    });

export default AllClaimsFacets;



// WEBPACK FOOTER //
// ./src/claim/all-claims/state/facets.js